import React from 'react';

export default function InvoiceAddress(props) {
	return (
		<div className="InvoiceAddressSection md:mx-2 min-w-80 my-2 p-2">
			<h2 className="text-md">
				<strong>FROM</strong>
			</h2>
			<span className="text-md">Travltax</span>
			<address>
				<div>5753 W Alder Ave.</div>
				<div>Littleton, CO 80128</div>
			</address>
		</div>
	);
}
